<template>
  <div class="product-selection" :class="{ 'product-selection-mobile': isMobile }">
    <div class="product-selection-title">
      <span class="icon">*</span>
      请选择与您隐私数据相关的产品
    </div>
    <div>
      <div class="product-selection-content">
        <div v-for="item in img" :key="item.productId">
          <div
            class="product-selection-content-img"
            :style="{
              background: `center center / 75% 75% no-repeat url(${item.productIcon}) #fff `,
              borderColor: `${item.productId === productID ? '#0076FC' : ''}`,
              boxShadow: `${
                item.productId === productID
                  ? '0px 1px 8px 0px rgba(138, 138, 138, 0.31)'
                  : ''
              }`,
            }"
            @click="click(item)"
          ></div>
          <!-- <div class="product-selection-content-title">{{ item.productName }}</div> -->
        </div>
      </div>
      <button class="btn" @click="nextStep">下一步</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "ProductSelection",
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      img: [
        {
          productIcon: require("@/assets/images/DSR/beike.png"),
          productId: "01_01",
          productName: "贝壳找房",
        },
        {
          productIcon: require("@/assets/images/DSR/lianjia.png"),
          productId: "01_02",
          productName: "链家",
        },
        {
          productIcon: require("@/assets/images/DSR/zufang.png"),
          productId: "01_04",
          productName: "贝壳租房",
        },
        {
          productIcon: require("@/assets/images/DSR/beiwo.png"),
          productId: "01_03",
          productName: "被窝",
        },
        {
          productIcon: require("@/assets/images/DSR/shengdu.png"),
          productId: "01_05",
          productName: "圣都整装",
        },
        {
          productIcon: require("@/assets/images/DSR/sheniu.png"),
          productId: "01_06",
          productName: "设牛",
        },
      ],
      state: false,
      productID: 0,
      productName: "",
    };
  },
  async created() {
    // this.readDictByKey("privacyAdminGuide", (res) => {
    //   this.img = res.list.dsrConfig.productList;
    // });
  },
  computed: {
    step() {
      return this.$store.state.app.step;
    },
  },
  methods: {
    nextStep() {
      if (this.productID) {
        this.$router.push("/dsr/type");
        this.$store.commit("app/CHANGE_STEP", 2);
        this.$store.commit("app/CHANGE_TAG", 2);
        this.$store.commit("app/CHANGE_TYPES", this.productID);
        this.$store.commit("app/CHANGE_NAME", this.productName);
      } else {
        this.$message({
          type: "warning",
          message: "请选择一类产品",
        });
      }
    },
    click(item) {
      this.productID = item.productId;
      this.productName = item.productName;
    },
  },
  mounted() {
    this.productID = this.$store.state.app.productType;
  },
};
</script>
<style lang="scss" scoped>
.product-selection {
  .icon {
    color: red;
  }
  .product-selection-title {
    font-size: calc($multiple * 0.215px * 80);
  }
  .product-selection-content {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: calc($multiple * 58px);
    .product-selection-content-img {
      position: relative;
      width: calc($multiple * 1.23px * 80);
      height: calc($multiple * 1.23px * 80);
      border-radius: calc($multiple * 0.1px * 80);
      margin: calc($multiple * 0.25px * 80);
      margin-bottom: calc($multiple * 0.09px * 80);
      background-color: #fff;
      border: 1px solid transparent;
      box-shadow: 0px 1px 5px 0px rgba(138, 138, 138, 0.22);
      background-size: contain !important;
      .el-icon-success {
        position: absolute;
        width: calc($multiple * 0.3px * 80);
        height: calc($multiple * 0.3px * 80);
        color: #0072f5;
        top: calc($multiple * -0.1px * 80);
        right: calc($multiple * -0.1px * 80);
      }
    }
    .product-selection-content-title {
      text-align: center;
      font-size: calc($multiple * 0.215px * 80);
    }
  }
  .btn {
    width: calc($multiple * 1.96px * 80);
    height: calc($multiple * 0.67px * 80);
    border-radius: calc($multiple * 0.1px * 80) !important;
    margin-left: calc($multiple * 3.5px * 80);
    text-align: center;
    padding: 0 !important;
    font-size: calc($multiple * 0.22px * 80);
    background: #0072f5;
    border: 0;
    color: #fff;
  }
}
.product-selection-mobile {
  font-size: 0.72rem;
  .product-selection-title {
    padding: 0.72rem 0;
    font-size: 0.72rem;
  }
  .product-selection-content {
    margin-bottom: 0.78rem;
    .product-selection-content-img {
      width: 3.28rem;
      height: 3.28rem;
      margin: 0.45rem;
      border-radius: 0.33rem;
      border: 1px solid transparent;
      box-shadow: 0px 1px 5px 0px rgba(138, 138, 138, 0.22);
    }
    .product-selection-content-title {
      font-size: 0.61rem;
      text-align: center;
    }
  }
  .btn {
    margin-top: 1.84rem;
    margin-bottom: 1.12rem;
    width: 6.56rem;
    height: 2.25rem;
    border-radius: 0.16rem !important;
    margin-left: 5.5rem;
    font-size: 0.72rem !important;
    background: #0072f5;
    border: 0;
    color: #fff;
    span {
      font-size: 0.72rem !important;
    }
  }
}
</style>
